import { Languages } from '@platform/client';
import { MultiSelectDropdown } from '@platform/components';
import { UseFormRegisterReturn } from 'react-hook-form';

type LanguageSelectionDropdownProps = {
  selectedLanguages: string[];
  onLanguageSelectionChange: (selectedLanguages: string[]) => void;
  register?: () => UseFormRegisterReturn<string>;
  errors?: Record<string, { message: string } | undefined>;
  selectionLimit?: number;
  placeholder?: string;
  label: string;
  omitEnglish?: boolean;
};
export const LanguageSelectionDropdown = ({
  selectedLanguages,
  onLanguageSelectionChange,
  register,
  errors,
  placeholder,
  label,
  selectionLimit,
  omitEnglish,
}: LanguageSelectionDropdownProps) => {
  const languages = Languages.useGetLanguages();
  const languageOptions =
    languages.isSuccess ?
      languages.data.flatMap((lang) => {
        if (omitEnglish && lang.name === 'English') {
          return [];
        }
        return [
          {
            label: lang.name,
          },
        ];
      })
    : [];
  return (
    <MultiSelectDropdown
      register={register}
      selectedItems={selectedLanguages}
      onSelectionChange={onLanguageSelectionChange}
      placeholder={placeholder || 'Select languages'}
      options={languageOptions}
      selectionLimit={selectionLimit}
      label={label}
      error={errors?.languages?.message}
      filterable={true}
    />
  );
};
